import { render, staticRenderFns } from "./ViewDoc.vue?vue&type=template&id=6d3ea74a"
import script from "./ViewDoc.vue?vue&type=script&lang=js"
export * from "./ViewDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports